import {ICar} from "@/modules/Car/interfaces/car.interface";
import {formatDateForServer} from "@/plugins/moment";
import {IApp} from "@/interfaces/app.interface";
import {ICarUnion} from "@/modules/CarList/interfaces/car-union.interface";
import {IAppState} from "@/interfaces/app-state.interface";
import {IBook} from "@/interfaces/book.interface";

export namespace ICarList {
  export enum Action {
    CarsMake = 'Cars_MK',
    CarsMove = 'Movs_MK',
    CarsUnionMake = 'CarsUnionMk',
  }

  export enum Commands {
    Get = 'get',
    Set = 'set',
    Add = 'add',
    Update = 'upd',
    UpdateUnion = 'update',
    Delete = 'del',
    RemoveFromHistory = 'delCarsHistory',
  }
  export enum CommandsMovements {
    Update = 'UPD',
    Add = 'ADD',
  }

  export enum ListingDisplayMode {
    Table = 'table',
    Cards = 'cards',
    EnterTable = 'enterTable',
  }

  export interface IState {
    carList: ICar.IEntity[];
    filters: IFilterItems;
    textInfo: string;
    payGuestHoursFlag: boolean;
    currentFilters: IFilterItems;
    activeSortedType: SortedType;
    sortDirectionUp: boolean;
    displayFilters: boolean;
    activeListingMode: ICarList.ListingDisplayMode;
    carUnionList: ICarUnion.IEntity[];

    loading: boolean;
  }

  export interface IFilterItems {
    fltCorpId: number;
    fltCorpName?: string;
    fltCarTypes: number[];
    fltStr: string;
    fltStatusId?: ICar.CarStatusId;
    date: [string, string],
    fltParkId?: number;
    guestFlag?: boolean;
  }

  export enum SortedType {
    OwnerByAlphabet = 'persName',
    DaysOnParking = 'dayInMonth',
    TimeOnParking = 'timePark',
    CarNumber = 'carNumber',
    CarStatusId = 'carStatusId',
    CorpName = 'corpName',
    ParkName = 'parkName',
    DateBeg = 'dateBeg',
    DateEnd = 'dateEnd',
    DateIn = 'dateIn',
    DateOut = 'dateOut',
    Balance = 'balance',
    TarifName = 'tarifName',
    TmPersonId = 'tmPersonId',
  }

  export enum LocalStorageKeys {
    SortedBy ='carListSoredBy',
    SortedDirection ='sortedDirection',
    ControlsDisplayMode = 'controlsDisplayMode',
    DisplayGuestInfoPopover = 'car-info-display-guest-popover',
    CorpIdForUploadCars = 'cars-list:corp-id-for-upload-cars',
    DisplayFilters = 'carListDisplayFilters',
  }

  export enum EmitterEvents {
    CLEAR_FILTERS = 'photo-reports-filter:clear',
    CREATE_CAR = 'car-list:created-car',
  }

  export function PrepareFilters(filters: IFilterItems, carUnionMode: boolean = false) {
    let filtersToSend: any = {};
    if (carUnionMode) {
      filtersToSend = {
        corpId: filters.fltCorpId,
        parkId: filters.fltParkId,
        statusId: filters.fltStatusId,
        commonFilter: filters.fltStr,
      }
    }
    else {
      filtersToSend = {...filters};
    }

    let dateInvalid = 'Invalid date';
    if (filters.date && !!filters.date[0] && !!filters.date[1] && filters.date[0] !== dateInvalid && filters.date[1] !== dateInvalid) {
      let dateBeg = formatDateForServer(filters.date[0], IApp.DATE_TIME_FORMAT_ELEMENT_UI);
      let dateEnd = formatDateForServer(filters.date[1], IApp.DATE_TIME_FORMAT_ELEMENT_UI);

      if (carUnionMode) {
        filtersToSend.dateBeg = dateBeg;
        filtersToSend.dateEnd = dateEnd;
      }
      else {
        filtersToSend.fltDateBeg = dateBeg;
        filtersToSend.fltDateEnd = dateEnd;
      }
    }
    if (filtersToSend.date) delete filtersToSend.date;

    for (const key in filtersToSend) {
      if (!filtersToSend[key]) delete filtersToSend[key];
    }
    return filtersToSend;
  }

  export function PrepareCarList(rootState: IAppState, carList: ICar.IEntity[]): ICar.IEntity[] {
    const carTypes = rootState.book.books[IBook.BookName.carTypes];
    const carTarifs = rootState.book.books[IBook.BookName.tarifs];
    const carListResult = carList.map((car: ICar.IEntity) => {
      let carTypePrint = '';

      const cartType = carTypes.find(item => item.id === car.carTypeId);
      if (cartType) carTypePrint = `[ ${cartType.name} ]`;

      return {
        ...car,
        carTypeName: carTypePrint,
        tarifName: car.tarifName
          ? car.tarifName
          : `${car.comment ? car.comment : ''} ${carTypePrint}`,
      }
    });

    return carListResult;
  }
}
